var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIncomplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "153.225 214.286 50.116 50.116",
    xmlns: "http://www.w3.org/2000/svg",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Icons",
    x: -365.807,
    y: 144.355,
    style: {
      fill: "none"
    },
    transform: "matrix(1, 0, 0, 1, 3.552713678800501e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 192.099 223.109 L 194.383 220.386 C 192.175 218.518 189.661 217.051 186.949 216.047 L 185.733 219.385 C 188.054 220.246 190.209 221.505 192.099 223.109 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(1, 0, 0, 1, 3.552713678800501e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 199.29 235.801 L 202.789 235.07 C 202.298 232.228 201.311 229.496 199.876 226.995 L 196.8 228.69 C 198.027 230.902 198.871 233.308 199.29 235.801 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(1, 0, 0, 1, 3.552713678800501e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 185.733 259.332 L 186.949 262.67 C 189.661 261.667 192.175 260.198 194.383 258.331 L 192.099 255.607 C 190.209 257.21 188.054 258.47 185.733 259.332 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(1, 0, 0, 1, 3.552713678800501e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 196.8 250.024 L 199.876 251.802 C 201.313 249.273 202.298 246.514 202.79 243.646 L 199.29 243.03 C 198.871 245.489 198.027 247.855 196.8 250.024 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(1, 0, 0, 1, 3.552713678800501e-15, 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 178.295 264.246 L 178.295 214.468 C 159.136 214.468 147.161 235.21 156.741 251.802 C 161.187 259.504 169.404 264.246 178.295 264.246 Z",
    style: {
      fill: "rgb(255, 255, 255)"
    },
    transform: "matrix(1, 0, 0, 1, 3.552713678800501e-15, 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "<Transparent Rectangle>",
    className: "cls-1",
    width: 56.889,
    height: 56.889,
    style: {
      fill: "none"
    },
    x: 149.85,
    y: 210.913,
    transform: "matrix(1, 0, 0, 1, 3.552713678800501e-15, 0)"
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncomplete);
export default __webpack_public_path__ + "static/media/incomplete.2f46314e25ee513e7adffe5ba7005c4f.svg";
export { ForwardRef as ReactComponent };